import { CheckBox, Clear, Save } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  Grid,
  Icon,
  IconButton,
  MenuItem,
  Radio,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import NormalTable from "../../../../Component/NormalTable";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import TableContainerComp from "../../../../Component/TableContainer";
import ErrorProps from "../../../../Component/Errorprops";

const Labour = ({ editData, handleCloseClick, type, woDetail }) => {
  const [labourData, setLabourData] = useState([]);
  const [labourSelect, setLabourSelect] = useState(editData);
  const [errorTime, setErrorTime] = useState("");
  const [quantity, setQuantity] = useState(editData.quantity);
  const [planHours, setPlanHours] = useState("0");
  const [workCenterOptions, setWorkCenterOptions] = useState([]);
  const [selectedWorkCenterIds, setSelectedWorkCenterIds] = useState(
    woDetail?.workCenterIdList || [],
  );
  const [labourLoading, setLabourLoading] = useState(false);

  useEffect(() => {
    getData();
  }, [woDetail]);

  const getData = async () => {
    try {
      const wcResponse = await axiosPrivate.get(
        "/selectlist/getallworkcenters",
      );
      setWorkCenterOptions(
        (wcResponse.data || []).filter(
          (wc) => wc.value && String(wc.text).toLowerCase() !== "none",
        ),
      );
    } catch (e) {
      setWorkCenterOptions([]);
    }

    const wcIds = woDetail?.workCenterIdList || [];

    setLabourLoading(true);
    try {
      const labourLink = masterAPI["labourCraft"].getlaboursbyworkcenters;
      const res = await axiosPrivate.post(labourLink, wcIds);
      const filterData = (res.data.result || []).filter(
        (fil) => editData.craftId === fil.craftId,
      );
      setLabourData(filterData);
    } catch (e) {
      setLabourData([]);
      console.log(e, "labourCraft WorkOrder");
    }
    setLabourLoading(false);

    const hours = Math.floor(editData.plannedHours);
    const minutes = Math.round((editData.plannedHours - hours) * 60);
    setPlanHours(`${hours}:${minutes < 10 ? "0" : ""}${minutes}`);
  };

  const handleGetLabour = async (wcIds) => {
    if (!wcIds || wcIds.length === 0) return;
    setLabourLoading(true);
    try {
      const labourLink = masterAPI["labourCraft"].getlaboursbyworkcenters;
      const res = await axiosPrivate.post(labourLink, wcIds);
      const filterData = (res.data.result || []).filter(
        (fil) => editData.craftId === fil.craftId,
      );
      setLabourData(filterData);
    } catch (e) {
      setLabourData([]);
    }
    setLabourLoading(false);
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: ({ cell }) => {
        const row = cell.row.original;
        return (
          <Radio
            checked={
              labourSelect.labourId === row.labourId &&
              labourSelect.craftId === row.craftId &&
              labourSelect.workCenterId === row.workCenterId
            }
            onClick={() => {
              handleCheck(cell.row.original);
            }}
          />
        );
      },
    },
    {
      Header: "Labour Name",
      accessor: "labourName",
      // disableFilters: true,
    },
    {
      Header: "Craft Name",
      accessor: "craftName",
      // disableFilters: true,
    },
    {
      Header: "Work Center",
      accessor: "workCenterName",
    },
  ];

  const handleCheck = (value) => {
    setLabourSelect(value);
  };

  const updateWorkOrderIfNeeded = async () => {
    const original = woDetail?.workCenterIdList || [];
    const changed =
      selectedWorkCenterIds.length !== original.length ||
      selectedWorkCenterIds.some((id) => !original.includes(id));
    if (changed && woDetail) {
      const updateLink = masterAPI["workOrder"].updateWorkcenter;
      await axiosPrivate.put(
        `${updateLink}/${woDetail.id}`,
        selectedWorkCenterIds,
      );
    }
  };

  const handleLabourSubmit = async () => {
    try {
      timeSchema.validateSync({ planHours }, { abortEarly: false });

      // ✅ valid
      setErrorTime("");
      console.log("Valid:", planHours);
      if (type === "wo") {
        const wotlink = masterAPI["workOrderTaskLabour"].update;
        let decimalPlanHours =
          Number(planHours.split(":")[0]) +
          Number(planHours.split(":")[1]) / 60;

        const putData = {
          id: editData.id,
          labourId: labourSelect.labourId,
          craftId: labourSelect.craftId,
          workCenterId: labourSelect.workCenterId || null,
          quantity: quantity,
          workOrderTaskId: editData.workOrderTaskId,
          plannedHours: decimalPlanHours,
          workedHours: decimalPlanHours,
        };
        console.log("Test", putData);

        await updateWorkOrderIfNeeded();
        await axiosPrivate
          .put(`${wotlink}`, putData)
          .then((res) => {
            console.log(res);
            handleCloseClick();
          })
          .catch((e) => {
            console.log(e, "createwotaskLabour");
          });
      } else {
        const jplink = masterAPI["jobPlanTaskLabour"].update;
        let decimalPlanHours =
          Number(planHours.split(":")[0]) +
          Number(planHours.split(":")[1]) / 60;
        const putData = {
          id: editData.id,
          labourId: labourSelect.labourId,
          craftId: labourSelect.craftId,
          workCenterId: labourSelect.workCenterId || null,
          quantity: quantity,
          jobPlanTaskId: editData.jobPlanTaskId,
          plannedHours: decimalPlanHours,
          workedHours: decimalPlanHours,
        };
        console.log(putData);

        await updateWorkOrderIfNeeded();
        await axiosPrivate
          .put(`${jplink}`, putData)
          .then((res) => {
            console.log(res);
            handleCloseClick();
          })
          .catch((e) => {
            console.log(e, "createjptaskLabour");
          });
      }
    } catch (err) {
      // ❌ get schema error
      setErrorTime(err.errors[0]);
    }
  };
  const timeSchema = Yup.object({
    planHours: Yup.string()
      .required("Time is required")
      .matches(/^\d+:[0-5]\d$/, "Format must be HH:MM and minutes 00-59"),
  });

  return (
    <Grid container sx={{ p: 1 }} spacing={"1.5rem"}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: "1.1rem",
              fontWeight: 500,
            }}
          >
            Labour
          </Typography>
          <Box>
            <IconButton
              onClick={() => {
                handleLabourSubmit();
              }}
            >
              <Save sx={{ color: "#2362B4" }} />
            </IconButton>
            <IconButton
              onClick={() => {
                handleCloseClick();
              }}
            >
              <Clear sx={{ color: "#2362B4" }} />
            </IconButton>
          </Box>
        </Box>
        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
      </Grid>
      <Grid container item xs={12} spacing={"1.5rem"}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: color.labelFontWeight,
              mb: color.labelmb,
              fontSize: color.labelFont,
            }}
          >
            Work Center
          </Typography>
          <Autocomplete
            multiple
            fullWidth
            options={workCenterOptions}
            getOptionLabel={(option) => option.text || ""}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            value={workCenterOptions.filter((wc) =>
              selectedWorkCenterIds.includes(wc.value),
            )}
            onChange={(_, newValue) => {
              const ids = newValue.map((v) => v.value);
              const isRemoval = ids.length < selectedWorkCenterIds.length;
              if (isRemoval && labourSelect?.labourId) {
                toast.warning(
                  "You have unsaved labour selections. Please save before changing the work center.",
                );
              }
              setSelectedWorkCenterIds(ids);
              handleGetLabour(ids);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                placeholder="Select Work Center"
              />
            )}
          />
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                // mb: color.labelmb,
                fontSize: color.labelFont,
                // color: color.labelColor,
                whiteSpace: "nowrap",
              }}
            >
              Quantity :
            </Typography>
            <TextField
              name="qauntity"
              size="small"
              placeholder="Enter Quantity"
              value={quantity}
              onChange={(e) => {
                setQuantity(e.target.value);
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                // mb: color.labelmb,
                fontSize: color.labelFont,
                // color: color.labelColor,
                whiteSpace: "nowrap",
              }}
            >
              Planned Hours(HH:MM) :
            </Typography>
            <Box>
              <TextField
                name="plannedHours"
                size="small"
                placeholder="HH:MM"
                value={planHours}
                onChange={(e) => {
                  setPlanHours(e.target.value);
                }}
              />
              <ErrorProps>{errorTime}</ErrorProps>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {labourLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <NormalTable data={labourData} columns={columns} filt={true} />
        )}
      </Grid>
    </Grid>
  );
};

export default Labour;
